import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, Input, Modal } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { dataDefault } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import TableText from "../../../TableText";
import FileSaver from "file-saver";
import compute from "./compute";
import "./index.scss";
import { numConvert, getJson } from '@/method';

const { MonthPicker } = DatePicker;
const { TextArea } = Input;
const { confirm } = Modal;

const totalIndex = [3, 4, 5, 9, 10, 11, , 15, 16, 17, 21, 22, 23, 27, 28, 29, 33, 34, 35];
const allListName = ["wedding_covers", "wedding_ac", "wedding_rev", "wedding_room", "wedding_other", "wedding_total", "wedding_proportion", "social_covers", "social_ac", "social_rev", "social_room", "social_other", "social_total", "social_proportion", "group_covers", "group_ac", "group_rev", "group_room", "group_other", "group_total", "group_proportion", "grand_covers", "grand_ac", "grand_rev", "grand_room", "grand_other", "grand_total"];

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            note: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        data = compute(data, this.state.date);
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);

        fetch(`/_6_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return a.sort - b.sort
                });
            }

            const month = moment(date).format('M');
            // 自动填充上个月的数据,一月份不适用此方法
            if (x.data.lastMonthData && x.data.lastMonthData.length > 0 && month > 1) {
                const lastMonthData = x.data.lastMonthData.sort((a, b) => {
                    return a.sort - b.sort
                });

                data = lastMonthData.map((item, i) => {
                    delete item.id;
                    if (data[i].id) {
                        item.id = data[i].id;
                    }
                    if (Math.ceil((i + 1) / 3) <= (Number(month) + 2) && Math.ceil((i + 1) / 3) > (month - 1) && i % 3 == 1) {
                        return { ...data[i] };
                    }
                    return item;
                });
            }
            // 填充预算数据，从当年一月份数据获取
            if (x.data.jan && x.data.jan.length > 0 && month > 1) {
                const jan = x.data.jan.sort((a, b) => {
                    return a.sort - b.sort
                });
                // 去年的实际数据填充到Actual Last Year
                data = data.map((item, i) => {
                    if (i <= 43 && i % 3 == 0) {
                        allListName.forEach(name => {
                            item[name] = getJson([i, name], jan);
                        });
                        return item
                    } else {
                        return item
                    }
                });
            }

            if (x.data.lastYearData && x.data.lastYearData.length > 0) {

                const lastYearData = x.data.lastYearData.sort((a, b) => {
                    return a.sort - b.sort
                });
                // 去年的实际数据填充到Actual Last Year
                data = data.map((item, i) => {
                    if (i <= 43 && i % 3 == 2) {
                        allListName.forEach(name => {
                            item[name] = getJson([i - 1, name], lastYearData);
                        });
                        return item
                    } else {
                        return item
                    }
                });
            }

            if (!data[0].id) {
                this.setState({
                    loading: false,
                    data,
                    note: x.data.note || {}
                }, () => {
                    this.onSave();
                });
                return
            }

            this.setState({ loading: false, note: x.data.note || {} });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x, i) => ({ ...x, year, month, }));
        if (month == 1) {
            const allListName = ["wedding_covers", "wedding_ac", "wedding_rev", "wedding_room", "wedding_other", "wedding_total", "wedding_proportion", "social_covers", "social_ac", "social_rev", "social_room", "social_other", "social_total", "social_proportion", "group_covers", "group_ac", "group_rev", "group_room", "group_other", "group_total", "group_proportion", "grand_covers", "grand_ac", "grand_rev", "grand_room", "grand_other", "grand_total"];
            data.forEach((item, i) => {
                if (i <= 43 && (i % 3 == 1) && i >= 8) {
                    allListName.forEach(name => {
                        data[i][name] = data[i - 1][name];
                    })
                }
            });
            this.setState({ data });
        }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('isAllId', data.every(x => x.id) ? 1 : 0);
        dataFrom.append('isAllNull', data.every(x => !x.id) ? 1 : 0);
        dataFrom.append('note', JSON.stringify({ ...this.state.note, year, month }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_6_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if ((data || []).every(x => !x.id)) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_1_1', 1.5, '6.11', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${moment(this.state.date).format('YYYY')} Catering & Events (C&E) Analysis By Market Segment 宴会活动分析 - 按市场细分`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table1').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const data = this.state.data;
        const year = moment(this.state.date).format('YYYY');
        const month = moment(this.state.date).format('M');
        const width = document.body.offsetWidth - 4050 > 300 ? document.body.offsetWidth - 4050 : 300;
        const print = this.state.print;
        const columns = [{
            title: 'MONTH',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * 0.5,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'textcenter',
                    name: "name",
                    onChange: this.onChange,
                    totalIndex
                };

                if (index < 42 && (index % 3 == 0)) {
                    return {
                        props: {
                            rowSpan: 3
                        },
                        children: <TableText data={props} />
                    }
                }

                if (index === 42 || index === 45) {
                    return {
                        props: {
                            rowSpan: 2
                        },
                        children: <TableText
                            data={{ ...props, text: index == 42 ? `% to Budget ${year}` : text }}
                        />
                    }
                }

                if (index === 44) {
                    return <TableText data={props} />
                }

                return {
                    props: {
                        rowSpan: 0
                    },
                }

            }
        }, {
            title: '',
            dataIndex: 'month_status',
            key: 'month_status',
            align: "center",
            fixed: this.state.print ? false : "left",
            width: width * 0.5,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange: this.onChange,
                    totalIndex
                };
                if (index < 40 && index != 38) {
                    let str = '';
                    if (index % 3 == 0) str = `Budget ${year}`;
                    if (index % 3 == 1) {
                        if (Math.ceil((index + 1) / 3) > month && Math.ceil((index + 1) / 3) <= (Number(month) + 2)) {
                            str = `Forecast ${year}`
                        } else {
                            str = `${Math.ceil((index + 1) / 3) <= month ? 'Actual' : "Budget"} ${year}`
                        }

                    };
                    if (index % 3 == 2) str = `Actual Last Year`;
                    // if (index == 34) {
                    //     if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) == month ? `Actual ${year}` : `Budget ${year}`} `;
                    // }
                    if (index == 37) str = `Actual ${year}`;
                    return <TableText data={{ ...props, text: str }} />
                }
                let t = '';
                if (index == 40) t = `Act/Fcst ${year}`;
                if (index == 38) t = `Variance%`;
                if (index == 41) t = `Variance%`;
                return (
                    <TableText
                        data={{
                            ...props,
                            text: t
                        }}
                    />
                )
            }
        }, {
            title: `Wedding`,
            width: 450,
            children: [{
                title: `Covers 人数`,
                dataIndex: 'wedding_covers',
                key: 'wedding_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `Covers 人数`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_covers",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A/C 人均消费`,
                dataIndex: 'wedding_ac',
                key: 'wedding_ac',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['Wedding', `A/C 人均消费`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_ac",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `REV 收益`,
                dataIndex: 'wedding_rev',
                key: 'wedding_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `REV 收益`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Meeting Room Rental 场租`,
                dataIndex: 'wedding_room',
                key: 'wedding_room',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `Meeting Room Rental 场租`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_room",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Other Revenue 其他收入`,
                dataIndex: 'wedding_other',
                key: 'wedding_other',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `Other Revenue 其他收入`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_other",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue 总收益 `,
                dataIndex: 'wedding_total',
                key: 'wedding_total',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `Total Revenue 总收益 `, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wedding_total",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue% 总收益占比`,
                dataIndex: 'wedding_proportion',
                key: 'wedding_proportion',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Wedding', `Total Revenue% 总收益占比`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "wedding_proportion",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };
                    return (
                        <TableText data={{ ...props, }} />
                    )
                }
            }]
        }, {
            title: `Social Events`,
            width: 450,
            children: [{
                title: `Covers 人数`,
                dataIndex: 'social_covers',
                key: 'social_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `Covers 人数`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_covers",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A/C 人均消费`,
                dataIndex: 'social_ac',
                key: 'social_ac',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['Social Events', `A/C 人均消费`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_ac",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `REV 收益`,
                dataIndex: 'social_rev',
                key: 'social_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `REV 收益`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Meeting Room Rental 场租`,
                dataIndex: 'social_room',
                key: 'social_room',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `Meeting Room Rental 场租`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_room",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Other Revenue 其他收入`,
                dataIndex: 'social_other',
                key: 'social_other',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `Other Revenue 其他收入`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_other",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue 总收益 `,
                dataIndex: 'social_total',
                key: 'social_total',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `Total Revenue 总收益 `, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "social_total",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue% 总收益占比`,
                dataIndex: 'social_proportion',
                key: 'social_proportion',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Social Events', `Total Revenue% 总收益占比`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "social_proportion",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };
                    return (
                        <TableText data={{ ...props, }} />
                    )
                }
            }]
        }, {
            title: `Group Events`,
            width: 450,
            children: [{
                title: `Covers 人数`,
                dataIndex: 'group_covers',
                key: 'group_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `Covers 人数`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_covers",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A/C 人均消费`,
                dataIndex: 'group_ac',
                key: 'group_ac',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['Group Events', `A/C 人均消费`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_ac",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };
                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `REV 收益`,
                dataIndex: 'group_rev',
                key: 'group_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `REV 收益`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Meeting Room Rental 场租`,
                dataIndex: 'group_room',
                key: 'group_room',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `Meeting Room Rental 场租`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_room",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Other Revenue 其他收入`,
                dataIndex: 'group_other',
                key: 'group_other',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `Other Revenue 其他收入`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_other",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';
                    if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有当前月份相邻的两个月包括当月可填写
                    if (!print &&
                        index < 36 &&
                        index % 3 == 1 &&
                        (Math.ceil((index + 1) / 3) > (month - 1) &&
                            Math.ceil((index + 1) / 3) <= (numConvert(month) + 2))
                    ) {
                        type = 'inputNumber';
                    }
                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue 总收益 `,
                dataIndex: 'group_total',
                key: 'group_total',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `Total Revenue 总收益 `, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "group_total",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue% 总收益占比`,
                dataIndex: 'group_proportion',
                key: 'group_proportion',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Group Events', `Total Revenue% 总收益占比`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "group_proportion",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };
                    return (
                        <TableText data={{ ...props, }} />
                    )
                }
            }]
        }, {
            title: `Grand Total`,
            width: 450,
            children: [{
                title: `Covers 人数`,
                dataIndex: 'grand_covers',
                key: 'grand_covers',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Grand Total', `Covers 人数`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_covers",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A/C 人均消费`,
                dataIndex: 'grand_ac',
                key: 'grand_ac',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['Grand Total', `A/C 人均消费`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_ac",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `REV 收益`,
                dataIndex: 'grand_rev',
                key: 'grand_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Grand Total', `REV 收益`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Meeting Room Rental 场租`,
                dataIndex: 'grand_room',
                key: 'grand_room',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Grand Total', `Meeting Room Rental 场租`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_room",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Other Revenue 其他收入`,
                dataIndex: 'grand_other',
                key: 'grand_other',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Grand Total', `Other Revenue 其他收入`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_other",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Total Revenue 总收益 `,
                dataIndex: 'grand_total',
                key: 'grand_total',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Grand Total', `Total Revenue 总收益 `, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "grand_total",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_6_1new"
                        }
                    };

                    let type = 'number';

                    if (index === 41 || index === 38) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 tableHeight">
                    <Row className="title" id="table4_1_1" style={{ width: this.state.print ? 4400 : 'auto' }}>
                        <Row>6.1.1 Catering & Events (C&E) Analysis By Market Segment 宴会活动分析 - 按市场细分</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />

                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            id="table1"
                            bordered
                            pagination={false}
                            rowClassName="protruding"
                            className="content"
                            style={{ width: this.state.print ? 4350 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 4350, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                        <Row
                            style={{ margin: "30px 0 0 10px" }}
                        >
                            Please critique if variance above +/- 5% 若差异数超过上下百分之五则需做出书面解释
                        </Row>
                        {
                            !this.state.loading && <TextArea
                                rows={4}
                                defaultValue={this.state.note.note || ""}
                                onBlur={e => {
                                    const value = e.target.value || "";
                                    this.setState({ note: { ...this.state.note, note: value } });
                                }}
                                style={{
                                    marginTop: 20
                                }}
                            />
                        }

                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_6_1">
                            <Button
                                type="primary"
                                style={{ margin: '0 10px' }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/6.0/6-1/6.1.1/index.js